import {combine, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {initFiltersList, initSortingsList} from 'core/hooks/grid2.0';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {
    data$,
    fetchDataFx,
    filters$,
    filtersChanged,
    filtersReset,
    filtersSubmit,
    Gate,
    listStateChanged,
    pageIncremented,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    sortings$,
    sortingsChanged,
    sortingsReset,
    stateReset,
} from './index';

data$
    .on(fetchDataFx.done, (state, {result}) => ({
        content: state ? state.content.concat(result.content) : result.content,
        hasNext: result.hasNext,
    }))
    .reset(sortingsChanged, filtersSubmit, Gate.close);
pageNumber$.reset(filtersSubmit, filtersReset, sortingsChanged, sortingsReset, stateReset);
pageSize$.reset(stateReset);

initFiltersList(filters$, filtersChanged, filtersReset, stateReset);
initSortingsList(sortings$, sortingsChanged, sortingsReset, stateReset);

sample({
    clock: pageIncremented,
    source: pageNumber$.map((state) => state + 1),
    target: pageNumberChanged,
});

sample({
    clock: merge([Gate.open, listStateChanged]),
    source: combine({
        sortings: sortings$,
        filters: filters$,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
    }),
    fn: ({filters, sortings, pageNumber, pageSize}) => ({
        paging: {
            pageSize,
            pageNumber,
        },
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
